// extracted by mini-css-extract-plugin
export default {"linkMenuItem":"LinksMenuItem_linkMenuItem__3dGIF","itemText":"LinksMenuItem_itemText__82U+E","active":"LinksMenuItem_active__MFfp0"};